import DocumentIcon from '@/common/assets/icons/searchDocumentation.svg?react';
import Typography from '@/common/components/base/typography/Typography';
import LoadingPage from '@/common/pages/LoadingPage';
import DocumentationGenerator from '@/modules/FileDetail/components/documentation/DocumentationGenerator.tsx';
import { documentationListQueryOptions } from '@/modules/FileDetail/queries/documentation/list/documentationListQueryOptions.ts';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { Box } from 'styled-system/jsx';

const DocumentationList = () => {
  const { id } = useParams();

  const { data, isError, isPending } = useQuery(
    documentationListQueryOptions(id!),
  );

  if (isError) {
    return <></>;
  }
  if (isPending) {
    return <LoadingPage />;
  }
  if (!data?.length) {
    return (
      <Box
        shadow="cardShadow"
        borderRadius="8px"
        p="16px"
        display="flex"
        justifyContent="center"
        alignItems="center"
        h="80vh"
      >
        <Box display="flex" flexDirection="column">
          <DocumentIcon />
          <Typography color="black-3">سندی ثبت نشده است !</Typography>
        </Box>
      </Box>
    );
  }
  return (
    <Box
      borderRadius="16px"
      backgroundColor="white"
      shadow="cardShadow"
      py="5px"
      mt="20px"
    >
      <DocumentationGenerator types={data} />
    </Box>
  );
};

export default DocumentationList;
